<template>
	<div class="card mt-4">
        <div class="card-header">
            <div class="row">
	            <div class="d-flex justify-content-between container-fluid">
			        <div class="text-muted fs-19">
			            <strong>
			            	<i class="fas fa-trophy mr-3"></i> 
			            	Rank de Categorias
			            </strong>
			        </div>
                    <bsh-dropdown-nav
                        id="categoriaNav"
                        :tabs="tabs"
                        @navChanged="ChangeChart">
                    </bsh-dropdown-nav>
				</div>
            </div>
        </div>
        <div class="card-body">
            <bsh-datatable 
				:columns="columns"
                :key="categoriaTableKey"
                v-if="link"
				:link="link"
				:doSearch="false">
			</bsh-datatable>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['date'],
		data(){
    		return {
                link: '',
                categoriaTableKey: 1,
                tabs: [
                    {
                        label: 'Mês',
                        field: 'mes'
                    },
                    {
                        label: 'Ano',
                        field: 'ano'
                    },
                    {
                        label: 'Geral',
                        field: 'geral'
                    }
                ],
                columns: [
                	{
                		label: '#',
                        field: 'rnum',
                        noSorting: true
                	},
                    {
                        label: 'Categoria',
                        field: 'nome',
                        noSorting: true
                    },
                    {
                        label: 'Quantidade',
                        field: 'quantidade',
                        noSorting: true
                    },
                    {
                        label: 'Desconto',
                        field: 'desconto',
                        noSorting: true
                    },
                    {
                        label: 'Valor',
                        field: 'valor',
                        noSorting: true
                    }
                ]
        	}
	    },
        created(){
            this.link = this.$url+'/api/adm/relatorios/categorias/rank/'+this.date+'?periodo=mes';
        },
        methods: {
            ChangeChart(chartPeriod){
                if(chartPeriod == 'geral'){
                    this.link = this.$url+'/api/adm/relatorios/categorias/rank/'+this.date+'?periodo=geral';
                }
                if(chartPeriod == 'ano'){
                    this.link = this.$url+'/api/adm/relatorios/categorias/rank/'+this.date+'?periodo=ano';
                }
                if(chartPeriod == 'mes'){
                    this.link = this.$url+'/api/adm/relatorios/categorias/rank/'+this.date+'?periodo=mes';
                }
                this.categoriaTableKey += 1;
            }
        }
	}
</script>
